export default "__VITE_ASSET__BrqkAW20__"